import {type LocationIdInput, Sort, TicketDirection, TicketStatus} from "app/gql/graphqlSchema";
import {createWithEqualityFn as zustandCreate} from "zustand/traditional";
import {immer} from "zustand/middleware/immer";
import {freeze} from "immer";

export interface TicketFilterState {
  direction: TicketDirection;
  locationIds: (LocationIdInput | null)[] | null;
  statuses: TicketStatus[] | null;
  query: string | null;
  page: {
    number: number;
    size: number;
    order: Array<{name: string; sort: Sort}>;
  };
}

const initialState = freeze<TicketFilterState>(
  {
    direction: TicketDirection.Recipient,
    locationIds: [],
    statuses: null,
    query: null,
    page: {
      number: 1,
      size: 10,
      order: [{name: "createdAt", sort: Sort.Desc}]
    }
  },
  true
);

export const useTicketFilterStore = zustandCreate(
  immer(() => initialState),
  Object.is
);

export const setTicketDirection = (direction: TicketDirection) =>
  useTicketFilterStore.setState((state) => {
    state.direction = direction;
    state.page.number = 1;
  });

export const setTicketFilter = (filter: {
  statuses: TicketStatus[] | null;
  query: string | null;
  locationIds: (LocationIdInput | null)[] | null;
}) =>
  useTicketFilterStore.setState((state) => {
    state.statuses = filter.statuses;
    state.query = filter.query;
    state.locationIds = filter.locationIds;
    state.page.number = 1;
  });

export const setTicketPageNumber = (number: number) =>
  useTicketFilterStore.setState((state) => {
    state.page.number = number;
  });
